export default "__VITE_ASSET__BYwcD1fp__"